import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { find, isEmpty, isNil, propEq } from 'ramda';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import AppActions from '~/actions/app';
import DevelopActions from '~/actions/develop';
import AddSchedule from './AddSchedule';
import EditSchedule from './EditSchedule';
import withNavigate from '~/hocs/withNavigate';

class IndividualTrainingSchedule extends Component {
    constructor(props) {
        super(props);

        const { userId, company, trainingSchedules, employees } = props;
        const id = Number(props.params?.id || 0);
        const editable = props.location?.state?.editable || false;
        const card = props.location?.state?.schedule;
        const schedule = find(propEq('id', id), trainingSchedules.data) || card;
        const scheduleUser = find(propEq('id', schedule?.user_id), employees) || {};

        if (!isNil(schedule)) {
            this.props.getScheduleDetail(schedule);
        }
        if (isNil(props.userAuthors) || isEmpty(props.userAuthors)) {
            this.props.getAuthors();
        }
        this.state = { userId, company, schedule, scheduleUser, editable };
    }

    handleFilter = (type, e) => {
        if (!isEmpty(e)) {
            if (type === 'assignee') {
                this.setState({ userId: e[0].id });
            } else {
                this.setState({ company: e[0] });
            }
        }
    };

    render() {
        const { userId, company, schedule, editable } = this.state;
        const { employees, globalCompanies, scheduleDetail, userAuthors, userRole, competencies } = this.props;

        return (
            <ErrorBoundary className="report-training-schedule-detail" dataCy="trainingSchedules">
                <Filter back="all training schedules" onBack={() => this.props.navigate(`/hcm/report-training-schedule`)} onChange={this.handleFilter} />
                {isNil(schedule) ? (
                    <AddSchedule
                        admin={true}
                        userId={userId}
                        authors={userAuthors}
                        companyId={company.id}
                        companies={globalCompanies}
                        employees={employees}
                        onModal={(e) => this.props.toggleModal(e)}
                        onSave={(e) => this.props.saveSchedule(e)}
                        onSelectCompany={(e) => this.props.selectCompany()}
                    />
                ) : (
                    <EditSchedule
                        editable={editable}
                        userId={userId}
                        userRole={userRole}
                        authors={userAuthors}
                        data={scheduleDetail}
                        company={company}
                        employees={employees}
                        competencies={competencies}
                        onBack={() => this.props.navigate(-1)}
                        onModal={(e) => this.props.toggleModal(e)}
                        onSave={(e) => this.props.saveSchedule(e)}
                        onDelete={(target, event, id, data) => this.props.deleteTemplate(target, event, id, data)}
                    />
                )}
            </ErrorBoundary>
        );
    }
}

IndividualTrainingSchedule.propTypes = {
    userId: PropTypes.number,
    userRole: PropTypes.number,
    userAuthors: PropTypes.array,
    company: PropTypes.shape({
        id: PropTypes.number,
    }),
    trainingSchedules: PropTypes.shape({
        current_page: PropTypes.number,
        last_page: PropTypes.number,
        per_page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        data: PropTypes.array,
    }),
    employees: PropTypes.array,
    competencies: PropTypes.array,
    globalCompanies: PropTypes.array,
    selectCompany: PropTypes.func,
    toggleModal: PropTypes.func,
    saveSchedule: PropTypes.func,
    deleteTemplate: PropTypes.func,
};

IndividualTrainingSchedule.defaultProps = {
    userId: 0,
    userRole: 1,
    userAuthors: [],
    company: {
        id: 0,
    },
    trainingSchedules: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        data: [],
    },
    employees: [],
    competencies: [],
    globalCompanies: [],
    selectCompany: () => {},
    toggleModal: () => {},
    saveSchedule: () => {},
    deleteTemplate: () => {},
};

const mapStateToProps = (state) => ({
    userId: state.app.id,
    userRole: state.app.app_role_id,
    userAuthors: state.app.userAuthors,
    company: state.app.company_info,
    employees: state.app.users,
    globalCompanies: state.app.companies,
    competencies: state.app.competencies,
    trainingSchedules: state.develop.trainingSchedules,
    scheduleDetail: state.develop.trainingScheduleDetail,
});

const mapDispatchToProps = (dispatch) => ({
    saveSchedule: (e) => dispatch(DevelopActions.librarysaveRequest(e)),
    deleteTemplate: (target, id, event, data) => dispatch(DevelopActions.libraryeventRequest(target, id, event, data)),
    getScheduleDetail: (e) => dispatch(DevelopActions.trainingscheduledetailRequest(e)),
    selectCompany: () => dispatch(AppActions.postmulticompanydataRequest()),
    getAuthors: () => dispatch(AppActions.getauthoringRequest()),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const IndividualTrainingScheduleWithNavigate = withNavigate(IndividualTrainingSchedule);

export default connect(mapStateToProps, mapDispatchToProps)(IndividualTrainingScheduleWithNavigate);
